import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useExportDialogStyles = makeStyles({
  dialogSurface: {
    maxWidth: "450px",
    "@media (max-width: 640px)": {
      minWidth: "unset",
      width: "calc(100vw - 32px)",
      maxWidth: "100%",
    },
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
    fontSize: designTokens.fontSize.sm,
  },
  dialogActions: {
    paddingTop: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[4],
  },
});
